import IApiResponse from '@/types/api-response'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getUserInfo } from '@/api/user'

interface AuthState {
    user: any,
    session_info: any
    error: string | null
}

const initialState: AuthState = {
	user: null,
    session_info: null,
    error: null
}


export const getSessionInfo = createAsyncThunk<
	IApiResponse<any>,
	void
>('user/user_info', async () => {
	return await getUserInfo()
})

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setUser(state, action) {
			state.user = action.payload
		},
		clearUser(state) {
			state.user = null
		},
	},
    extraReducers: (builder) => {
            builder
                .addCase(getSessionInfo.pending, (state) => {
                    state.error = null
                })
                .addCase(getSessionInfo.fulfilled, (state, { payload }) => {
                    state.session_info = payload.success ? payload.data : null
                })
                .addCase(getSessionInfo.rejected, (state, action) => {
                    state.error = action.error.message || 'Something went wrong'
                })
        },
})

export const { setUser, clearUser } = authSlice.actions
export default authSlice.reducer
